import { render } from "./editProductCat.vue?vue&type=template&id=7d7b323a"
import script from "./editProductCat.vue?vue&type=script&lang=js"
export * from "./editProductCat.vue?vue&type=script&lang=js"

import "./editProductCat.vue?vue&type=style&index=0&id=7d7b323a&lang=css"
script.render = render

export default script